import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';


import { NgForm } from '@angular/forms';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import { SubjectBillingItem } from '../../../shared/models/subjectBillingItem.model';

import { SubjectInvoiceItem } from '../../../shared/models/subjectInvoiceItem.model';


import { Payment } from './../../../shared/models/payment.model';
import { InvoicePayment } from '../../../shared/models/invoicePayment.model';



// Import the MyoAPIPaymentsToolsWidget - to use the functions
// place in the providers of the page.
import { MyobApiInvoicePaymentSyncToolsWidgetComponent } from './../../../components/myob/myob-api-invoice-payment-sync-tools-widget/myob-api-invoice-payment-sync-tools-widget.component';
import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { Brand } from './../../../shared/models/brand.model';

@Component({
  selector: 'app-client-invoice-bulk-payment-widget',
  templateUrl: './client-invoice-bulk-payment-widget.component.html',
  styleUrls: ['./client-invoice-bulk-payment-widget.component.css']
})
export class ClientInvoiceBulkPaymentWidgetComponent implements OnInit, OnChanges {


  @Input() job_id;
  @Input() subject_id;
  @Input() subject_number;
  @Input() job_number;
  @Input() to_brand_id;

  @Input() is_create_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  @Input() is_update_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  @Input() invoice_id?; // impliments on changes.
  @Input() invoice_number?; // impliments on changes.

  // setup as observable?
  @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'bulk'; // side | abstract | full / single / bulk
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModel3') closeParentModel3: EventEmitter<any> = new EventEmitter(); // simple close window
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();

  @Output('refreshSujectInvoicePage') refreshSujectInvoicePage: EventEmitter<any> = new EventEmitter();
     // access the template form
     @ViewChild('invoicePaymentForm') invoicePaymentForm: NgForm;


     @Output('rowDeselect') rowDeselect: EventEmitter<any> = new EventEmitter();

     @Input() search_count?; // if > 1 there is array of work_order is that will atomatically be added to the payment array
     @Input() search_array?; // if > 1 there is array of work_order is that will atomatically be added to the payment array


     // pass selcected objects
    @Input() search_results?; 


  job: Object;
  billing_tasks: Object;
  model: any;
  combo_model: Brand;

  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  job_type: Object;
  job_type_name: any;
  job_type_id: any;
  job_type_location: Object;
  job_type_location_name: any;
  job_type_court: Object;
  job_type_court_name: any;
  new_subject_billing_item_id: any;
  returned_subject_billing_item_id: any;
  new_invoice_item_id: any;
  returned_invoice_item_id: any;
  
  invoiceItemsList: any = [];
  invoiceItemsList2: SubjectInvoiceItem;
  invoicePaymentItemsList: any = [];
  invoicePaymentModelList: any = [];
  invoice_model: SubjectInvoice;
  new_list: any;

  paymentModel: Payment = new Payment(); // sets up the model correctly on create.
  invoicePaymentModel: InvoicePayment = new InvoicePayment(); // sets up the model correctly on create.
 

  invoice_item_model: any = SubjectInvoiceItem;
  myob_account_codes: any;
  myob_tax_codes: any;
  invoiceItem: any;

  invoice_total: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  new_payment_id: any;
  returned_payment_id: any;
  invoice_update_payment_model: any = [];
  brands: any;
  invoicePaymentItemsList_total_all: any;
  invoicePaymentItemsList_remaining_total_all: any;
  invoicePaymentItemsList_gst_total_all: any;
  invoicePaymentItemsList_subtotal_all: any;
  invoicePaymentItemsList_payment_total_all: any;

  @Input() process_state: string;
  @Input() process_notice: any = null;


  public today = Date.now();
  // process_notice: any = null;
  subject_invoice: SubjectInvoice;
  baseUploadURL: string;
  brands_client: any;
  brands_agent: any;

  // maps the appropriate column to fields property
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' };
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  invoice_to_brand_name: any;

  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  invoice_status_all: any;
  invoice_payment_status_all: any;
  invoice_communication_status_all: any;

 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute, public toastr: HotToastService,
    // vcr: ViewContainerRef, 
    private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public myobApi_IPTW: MyobApiInvoicePaymentSyncToolsWidgetComponent,

 ) {



 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

  // this.toastr.setRootViewContainerRef(vcr);

  // Combo Box Options
  this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
      this.getBrandsComboBoxClients(this.combo_model);
      this.getBrandsComboBoxAgents(this.combo_model);

      this.getInvoiceStatusAll();
      this.getInvoicePaymentStatusAll();
      this.getInvoiceCommunicationStatusAll();

  }

  // check for changes. to load data.
  ngOnChanges(changes) {


this.paymentModel = new Payment();  // starts a new empty payment model
this.invoicePaymentModel = new InvoicePayment();  // starts a new empty payment model



//  this.invoicePaymentItemsList = new SubjectInvoice(); // starts a new empty payment model
//  this.invoicePaymentModelList = new InvoicePayment(); // starts a new empty payment model
    // this.getInvoice(this.invoice_id);
    // this.getMyobAccountCodes();

    this.paymentModel.payment_total = 0; // set to zero as to prevent NaN errors.
    this.invoicePaymentModel.subject_number = this.subject_number;
    this.invoicePaymentModel.job_number = this.job_number;

   if (changes.invoice_id) {
     // deal with asynchronous Observable result
    // this.invoice_id = changes.invoice_id.currentValue;
    // this.getInvoice(this.invoice_id);
    // this.getMyobAccountCodes();

   }
 }


  ngOnInit() {
    this.getBrands();
    this.getMyobAccountCodes();
    this.getMyobTaxCodes();


    this.paymentModel.payment_total = 0; // set to zero as to prevent NaN errors.
    this.paymentModel.to_brand_id = this.to_brand_id; // set to zero as to prevent NaN errors.
    this.invoicePaymentModel.subject_number = this.subject_number;
    this.invoicePaymentModel.job_number = this.job_number;

    if(this.invoice_id >= 1 ) {
      this.getSubjectInvoice(this.invoice_id); // this pushees the invoice to the invoicePaymentItemsList[] ready for payment.

    }




// has to be a valid search count as well as a valid search array if work_orders
if (this.search_count >= '1' ) {
  // Loop through the work order array.
  // console.log('Passed ', JSON.stringify(this.search_array));
  let newArr = Object(this.search_array);
  const  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
     // Run the job data queries.
     // need to do a loop of subject_billing items (.length)
     for (let i = 0; i < count_of_items; i++) {
       let res = newArr[i];
      console.log('Invoice to Add: ' + res.invoice_id);
      if(res.invoice_id != null) {
        this.getSubjectInvoice(res.invoice_id); // this pushees the invoice to the invoicePaymentItemsList[] ready for payment.
      }
    }
}





  }



pushInvoiceToPay(invoice_model){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));


  // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
if (!this.invoicePaymentItemsList.some(el => el.invoice_id === invoice_model.invoice_id)) {
  this.invoicePaymentItemsList.push({
    // JSON.stringify(invoice_model)
    ...invoice_model, // this little bit of code maps the json objects/models together without having to do it all by hand.
    invoiceUID: invoice_model.myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
  });
}




  // Caclulate the Full invoicePaymentsItemsList totals.


// Do calculations


// commented out for testing check boxes to see if works better without calutions runnting all the time.
  this.doCalculations();

}


// New way May mange search results from the below component.... 2025
refreshInvoicesToPay(search_results){
  this.toastr.warning("refreshing invoices to pay");
  this.search_results = search_results;
  this.invoicePaymentItemsList = search_results;

    this.doCalculations();

}

// clear invoices
resetInvoicesToPay(){
  this.toastr.warning("reset invoices to pay");
  this.search_results = []; // clear the holding model.
  this.invoicePaymentItemsList = []; // clear invoice items on this component
    this.doCalculations();

}


// can also run from a child component.
doCalculations() {


  this.toastr.info('recalulating totals due.')

  if(this.invoicePaymentItemsList.length >= 1){

    // Caclulate the Full invoicePaymentsItemsList totals.
    this.invoicePaymentItemsList_total_all = this.invoicePaymentItemsList.filter((item) => item.invoice_total)
    .map((item) => +item.invoice_total)
    .reduce((sum, current) => sum + current);
this.invoicePaymentItemsList_subtotal_all = this.invoicePaymentItemsList.filter((item) => item.invoice_subtotal)
    .map((item) => +item.invoice_subtotal)
    .reduce((sum, current) => sum + current);
this.invoicePaymentItemsList_remaining_total_all = this.invoicePaymentItemsList.filter((item) => item.invoice_remaining_total)
    .map((item) => +item.invoice_remaining_total)
    .reduce((sum, current) => sum + current);
this.invoicePaymentItemsList_payment_total_all = this.invoicePaymentItemsList.filter((item) => item.invoice_payment_total)
    .map((item) => +item.invoice_payment_total)
    .reduce((sum, current) => sum + current);
this.invoicePaymentItemsList_gst_total_all = this.invoicePaymentItemsList.filter((item) => item.invoice_gst)
    .map((item) => +item.invoice_gst)
    .reduce((sum, current) => sum + current);


    this.paymentModel.from_brand_id = 94; // Owner Sharmans hard coded
    this.paymentModel.myob_bank_account_code_id = null; // not used
    this.paymentModel.created_by = this.sessionUserId;
    // this.paymentModel.created_date = this.today;
    this.paymentModel.updated_by = this.sessionUserId;
    // this.paymentModel.updated_date = this.today;
    if (this.widget_size === 'bulk'){
    this.paymentModel.is_bulk = 1; // for bulk payments only
   }

  }else{
    // Update for checkboxes
    // if the last one.
    this.invoicePaymentItemsList_subtotal_all = 0
    this.invoicePaymentItemsList_remaining_total_all = 0
    this.invoicePaymentItemsList_payment_total_all = 0
    this.invoicePaymentItemsList_gst_total_all = 0
  }


    // now validate the form;
   // this.calculateTotalRemaining();
}



calculateTotalRemaining() {
  // uses form values using form ngForms
//  this.invoicePaymentModel.remaining_total =
//  this.invoicePaymentForm.controls['invoice_total'].value - this.invoicePaymentForm.controls['payment_total'].value;
//  this.invoicePaymentForm.controls['remaining_total'].setValue( this.invoicePaymentModel.remaining_total);

this.toastr.info('recalulating totals remaining.')


const remaining =  this.invoicePaymentModel.remaining_total - this.invoicePaymentForm.controls['payment_total'].value;
// perfect pay
if (remaining === 0) {
// this.toastr.success('Perfect... You may apply the payment.');
}

// overpay
if (remaining < 0) {
 this.toastr.warning('Over Payment of Invoice Alert!');
// set the form to invalid for entry
this.invoicePaymentForm.form.controls['remaining_total'].setErrors({'incorrect': true});
 }
// underpay
 if (remaining > 0) {
   this.toastr.error('The Value Paid is less than the invoice amount?');
   this.invoicePaymentForm.form.controls['remaining_total'].setErrors({'incorrect': true});
   }


}




// Set up INvoice defaults for SINGLE
getSubjectInvoice(invoice_id) {
  this._demoService.getSubjectInvoice(invoice_id).subscribe(
     data => { this.subject_invoice = data;
   let res = data[0];
  // this.subject_invoices = res; // only return the first result and save back the the same variable.
   // do a count if exists
    // Automatically Load the invoice For Payment / Single
    console.log('SingleI Invoice Pushed Model: ' + JSON.stringify(data));
    }, // make the same data call for all
     err => console.error(err),
     () => {
      this.pushInvoiceToPay(this.subject_invoice[0]);
      this.doCalculations();
     }
   );
 }




 getBrandsComboBoxClients(combo_model) {
  this.combo_model.brand_type_id = 2;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_client = data;
      // this.invoice_to_brand_name = this.brands_client.name;
          // setup the brand name for single
            // tslint:disable-next-line:max-line-length
            if(this.to_brand_id >= 1){
            let toBrandArr = Object(data).filter((sb)=>(sb.brand_id === this.to_brand_id)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
            console.log('toBrandArr: ' + JSON.stringify(toBrandArr));
            this.invoice_to_brand_name = toBrandArr[0].name;
            // let  count_of_items = invoicePaymentItemsList.length;
                      // for(let i=0;i < count_of_items; i++) {
            }
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getBrandsComboBoxAgents(combo_model) {
 this.combo_model.brand_type_id = 3;
this._demoService.getBrandsComboBox(combo_model).subscribe(
   data => { this.brands_agent = data; },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}





// Apply Bulk Invoice Payment Wizard

public applyBulkPaymentWizardNoMyob(paymentModel, invoicePaymentItemsList) {

  // Step 1 : InsertLocalPaymentRecords (Payment + Invoice_Payemnts)

        // loop and Create Local Versions
        // :: Loop a first. Objects
        let  count_of_items = invoicePaymentItemsList.length;
        for (let i = 0; i < count_of_items; i++) {
         //  let res = invoicePaymentItemsList[i];
        // create combined models  this.invoicePaymentModelList.push({});
        // this.invoicePaymentItemsList = {}; // set to empty
            // this.invoicePaymentModelList.push({
            //   ...invoicePaymentItemsList[i],
            //   payment_amount: invoicePaymentItemsList[i].invoice_total,
            //   myob_account_code_id: invoicePaymentItemsList[i].myob_account_code_id,
            // //  payment_total: invoicePaymentItemsList[i].invoice_total,
            //   remaining_total: 0,
            //   is_bulk: 1, // set so that repeater bulk invoice function works.
            //     ...paymentModel,
            //   payment_total: invoicePaymentItemsList[i].invoice_total,
            // });

            this.invoicePaymentModelList = [{
              ...invoicePaymentItemsList[i],
              payment_amount: invoicePaymentItemsList[i].invoice_total,
              myob_account_code_id: invoicePaymentItemsList[i].myob_account_code_id,
            //  payment_total: invoicePaymentItemsList[i].invoice_total,
              remaining_total: 0,
              is_bulk: 1, // set so that repeater bulk invoice function works.
                ...paymentModel,
              payment_total: invoicePaymentItemsList[i].invoice_total,
            }];

            console.log('i: ' + i);
            console.log('this.invoicePaymentModelList' + JSON.stringify(this.invoicePaymentModelList[0]));
            // this.createSubjectPaymentW(this.invoicePaymentModelList[i]); // loop the lot mulitple record of the payment list of invoices
            this.createSubjectPaymentW(this.invoicePaymentModelList[0]); // a single record of the payment list of invoices
        } // end loop of invoicePaymentItemsList






  // step 2 : Get + Build invoicePaymentItems Object (Invoice + Payments + Invoice_Payment ) SQL join return
                







  // Step 3 : Do the Loop of invoicePaymentItems(Invoices + Payments) // by count of payments made by invoice

    // Step 4 : [ Inside Loop] Post MYSQL Payment[i]

                  // Step 5 (from response -> (UID) :: 
                          // SET returnedUID: as public variable.
                  // End Resonse };

    // Step 6 :: Look Up MYOB AGAIN FOR VERSING after post.

          // Step 7 :: Insert new payment versions details from response

    // Step 8 :: Lookup Myob Invoice from Loop invoiceUID

          // Step 9 :: Upate Local Invoices with new Version & payment Details. (status allready updated above in step 1 return)

  // Step 10: } Looop End Loop


  // New functino for trigger of bulk payments - March 2024
          let bulk_log_content_model = {
            invoicePaymentItemsList: invoicePaymentItemsList,
            ...invoicePaymentItemsList[0], // Send the first invoice details so that we can get or load the variables for Automations
            ...paymentModel,
            payment_BULK_snapshot : document.getElementById('payment_BULK_snapshot').innerHTML, // copy all formatting. ///innerHTML
          }
          


          // this.gfunc.insertLog_createWorkOrderPaymentBulk(bulk_log_content_model);
          this.gfunc.insertLog_createInvoicePaymentBulk(bulk_log_content_model);


  // Step 11:  End Function Process. // Done
  this.process_notice = '...Done! Your payment records are now sycronised with the Myob Cloud.';
  // this.toastr.success('<b>We Are Done!</b> Thank you <li class"fa fa-thumbs-o-up"></li>');
 };





    // :: Step 1 Functions

 createSubjectPaymentW(model){
  // :: do the magic here from the form.input model
  this._demoService.createPayment(model).subscribe(
   (data) => {
     this.new_payment_id = data;
     //  let res = data[0];
   this.returned_payment_id = this.new_payment_id.last_insert_id;
  //  console.log('payment id: ' + this.returned_payment_id);
   // now insert the invoice payment record.
 
  
  },
   (err) => console.error(err),
  () => {
    // console.log('Brand Loaded.');
 /// MOved up from here.
   this.createSubjectInvoicePaymentW(model, this.returned_payment_id);
  }
    );
}

createSubjectInvoicePaymentW(model,  payment_id) {
 // :: do the magic here from the form.input model
 const sent_model = model;
 this._demoService.createSubjectInvoicePayment(model, payment_id).subscribe(
  (data) => {
  //  this.new_payment_id = data;
    //  let res = data[0];
// we now need to update the invoice record with
let payment_status = 2;
let invoice_status = 5;
// partially paid - not allowed yet
if (sent_model.remaining_total > 0) {
payment_status = 3; // partially paid
invoice_status = 4; // approved PDF
}
// if fully paid or more.
if (sent_model.remaining_total < 0){
 payment_status = 2; // fully paid
 invoice_status = 5; // closed
 }
// Fixes invoice paymet payment items totals to the invoice value here (regarless of Wizard overallpaymet amount.)
this.invoice_update_payment_model = {
 invoice_id: model.invoice_id,
 invoice_payment_total: model.invoice_total,
 invoice_remaining_total: 0,
 invoice_status_id: invoice_status, // closed
 invoice_payment_status_id: payment_status, // fully paid
 updated_by: this.sessionUserId,
};



},
(err) => console.error(err),
() => {
 // moved this up

 // Update/Insert Payment Myob Function
// this.createMyobPaymentLocalFunctionW(this.invoice_update_payment_model, model, payment_id);
// Update local value
this.updateInvoiceAfterPaymentFiguresW(this.invoice_update_payment_model, model, payment_id);
}
);
}

updateInvoiceAfterPaymentFiguresW(invoice_update_payment_model, model, payment_id){
    this._demoService.updateInvoiceAfterPaymentFigures(invoice_update_payment_model).subscribe(
    (data) => {
      // this.new_payment_id = data;
      // let res = data[0];
      this.gfunc.insertLog_createInvoicePayment(model);
    },
    (err) => console.error(err),
    () => {
      // console.log('.');
  this.toastr.success('Payment + Invoice Record(s) Applied');
          // Step 11:  End Function Process. // Done
  this.process_notice = '...Done! Your payment records are now sycronised with the Myob Cloud.';
  this.process_state = 'end';


          }
    );
    };


    // Setp 2 Functions





























  deleteInvoiceToPayItem(key: number) {
    // grid
    // this.toastr.info("clicked remove")
    let data = this.invoicePaymentItemsList;

    this.toastr.success("Key Send: " + key )

  let key_order_id = key
// Fitters amd retirms tje 


// added a loop to the functino to correct the removal may 2025
let count_selected = this.invoicePaymentItemsList.lenght



this.invoicePaymentItemsList= this.invoicePaymentItemsList.filter(function (order) {
      // return true for salary greater than equals to 25000
      console.log('leaving IDs= ' + data[0]['invoice_id'] + ' != ' + key_order_id);
      // return order.invoice_id != data[i]['invoice_id'];
      return key_order_id != data[0]['invoice_id'];
    });


    // this.invoicePaymentItemsList =  new_list;




  //   this.new_list =  this.invoicePaymentItemsList.filter(function (order) {
  //     // return true for salary greater than equals to 25000
  //     console.log('leaving IDs= ' + data[0]['invoice_id'] + ' != ' + key_order_id);
  //     // return order.invoice_id != data[i]['invoice_id'];
  //     return key_order_id != data[0]['invoice_id'];
  //   });


  // this.invoicePaymentItemsList = this.new_list;

    // TODD:
    // emitter function to remove the items in the check boxes in below component....
    // this.rowDeselect.emit(data[0])


  // turn off for testing to make it do manually to stop it wigging out....
  this.doCalculations();

  

       };

  getBrands() {
    this._demoService.getBrands().subscribe(
       data => { this.brands = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getMyobAccountCodes() {
    this._demoService.getMyobAccountCodes().subscribe(
       data => { this.myob_account_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getMyobTaxCodes() {
    this._demoService.getMyobTaxCodes().subscribe(
       data => { this.myob_tax_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   createClientBulkInvoicePayment(model, invoicePaymentItemsList) {

// TOD INSTRUCTIONS
// and think about running existing varibales in a loop of invoicePaymentItemsList.
//:: Original FIrst Insert the Payment
this.createSubjectPaymentBulk(model, invoicePaymentItemsList);

//:: Next function create the invoicePayment Data Record.

// :: Then myob functions.

    // :: do the magic here from the form.input model
            //   this._demoService.createPayment(model).subscribe(
            //    (data) => {
            //      this.new_payment_id = data;
            //      //  let res = data[0];
            //    this.returned_payment_id = this.new_payment_id.last_insert_id;
            //    console.log('payment id: ' + this.returned_payment_id);
            //      // now insert the invoice payment record.
            //     //  this.createSubjectInvoicePayment(model, this.returned_payment_id);
            //    },
            //    (err) => console.error(err),
            //   // () => console.log('Brand Loaded.')
            //  );
   // try here as payment id as not inserting in the subscription
 
 }

/*

// Sent Values in a Single Payment Process
       Form Values:
        {
  "payment_date": "2022-04-12T14:00:00.000Z",
  "payment_total": "600",
  "myob_account_code_id": "1",
  "invoice_number": "1100.1.1.1",
  "invoice_total": "400",
  "remaining_total": -200,
  "invoice_id": "28",
  "from_brand_id": "94",
  "to_brand_id": "97",
  "created_by": "66",
  "subject_id": "439",
  "subject_number": "1100.1.1.1",
  "job_id": "1100",
  "job_number": "1100.1"
}
        paymentModel:
        {
  "payment_total": "600",
  "subject_number": "1100.1.1.1",
  "job_number": "1100.1",
  "payment_date": "2022-04-12T14:00:00.000Z",
  "myob_account_code_id": "1"
}
        invoicePaymentModel
        {
  "subject_number": "1100.1.1.1",
  "job_number": "1100.1",
  "remaining_total": -200
}


*/






// Original Creat Payment Functions below so I can see if they work for bulk as well.

 createSubjectPaymentBulk( model, invoicePaymentItemsList) {
  // :: do the magic here from the form.input model

  this._demoService.createPayment(model).subscribe(
   (data) => {
     this.new_payment_id = data;
     //  let res = data[0];
   this.returned_payment_id = this.new_payment_id.last_insert_id;
   console.log('payment id: ' + this.returned_payment_id);
     // now insert the invoice payment record.


    
      // Bulk Paymets this will have to loop through the invoicePaymentItemsList
      // So do this outside a subscription??? maybe
      // 


      // :: Loop a first. Objects
           // tslint:disable-next-line:max-line-length (these are Invoices)
          //  let newArr = Object(invoicePaymentItemsList).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
           let  count_of_items = invoicePaymentItemsList.length;
           for(let i=0;i < count_of_items; i++) {
          //  let res = newArr[i];
        
            console.log('Invoice Item Update: ' + i);
            console.log('invoicePaymentItemsList' + invoicePaymentItemsList);
            this.invoicePaymentModelList = [{
              // // JSON.stringify(invoice_model)
           ...invoicePaymentItemsList[i], // this little bit of code maps t
              // invoice_remaining_total: 0, // paid
              // // payment_amount: invoicePaymentItemsList.invoice_total,
              // invoice_payment_status_id: 2, // paid (there is a part paid but not implimented)
              // invoice_status_id: 5, // closed
              // // required for Insert Invoice Payment Items
                invoice_id: invoicePaymentItemsList[i].invoice_id,
                payment_id :   this.returned_payment_id,
                payment_amount: invoicePaymentItemsList[i].invoice_total,
                payment_date: model.payment_date,
                myob_account_code_id: invoicePaymentItemsList[i].myob_account_code_id,
                payment_total: invoicePaymentItemsList[i].invoice_total,
                remaining_total: 0,
                invoice_total: invoicePaymentItemsList[i].invoice_total, // paid
                created_by: model.created_by,
                updated_by: model.updated_by,

                // invoice_id: model.invoice_id,
                // payment_id :   this.returned_payment_id,
                // payment_amount: model.invoice_total,
                // payment_date: model.payment_date,
                // myob_account_code_id: model.myob_account_code_id,
                // payment_total: model.invoice_total,
                // remaining_total: 0,
                // invoice_total: model.invoice_total, // paid
                // created_by: model.created_by,
                  // updated_by: model.updated_by,
                  is_bulk: 1, // set so that repeater bulk invoice function works.
                  ...model
                }];

                console.log('InvoiceID: ' + invoicePaymentItemsList[i].invoice_id);
                console.log('InvoiceNUmber: ' + invoicePaymentItemsList[i].invoice_number );
                // console.log('New invoicePaymentModelList: ' + JSON.stringify(this.invoicePaymentModelList));

            // craete the model here and then push.

           this.createSubjectInvoicePaymentBulk(model, this.returned_payment_id, this.invoicePaymentModelList[0]);

           } // end loop of invoicePaymentItemsList
   },
   (err) => console.error(err),
  // () => console.log('Brand Loaded.')
 );
 // try here as payment id as not inserting in the subscription

}


createSubjectInvoicePaymentBulk(model,  payment_id, invoicePaymentModelList) {
 // :: do the magic here from the form.input model
//  let sent_model = model;

let sent_model = model;

console.log('SentModel: ' + sent_model);

 this._demoService.createSubjectInvoicePayment(invoicePaymentModelList, payment_id).subscribe(
  (data) => {
  //  this.new_payment_id = data;
    //  let res = data[0];
// we now need to update the invoice record with
let payment_status = 2;
let invoice_status = 5;
// partially paid - not allowed yet
if (sent_model.remaining_total > 0) {
payment_status = 3; // partially paid
invoice_status = 4; // approved PDF
}
// if fully paid or more.
if (sent_model.remaining_total < 0){
 payment_status = 2; // fully paid
 invoice_status = 5; // closed
 }
// Fixes invoice paymet payment items totals to the invoice value here (regarless of Wizard overallpaymet amount.)
this.invoice_update_payment_model = {
 invoice_id: invoicePaymentModelList.invoice_id,
 invoice_payment_total: invoicePaymentModelList.invoice_payment_total, // was this the issue
 invoice_remaining_total: model.remaining_total,
 invoice_status_id: invoice_status, // closed
 invoice_payment_status_id: payment_status, // fully paid
 updated_by: this.sessionUserId,
};

// ::
// :: BUG: The the loop buggers out with a bad request for the MYOB BULK after 2 payemnts.
// creating errors due to the update ofinvoices as well in loop I think
// Update/Insert Payment Myob Function
this.createMyobPaymentLocalFunction(this.invoice_update_payment_model, model, payment_id);

// :: Commented this out to check if its breaking the update myob bilk payment script above.
// Update local values
this.updateInvoiceAfterPaymentFigures(this.invoice_update_payment_model, model, payment_id);
},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}

createMyobPaymentLocalFunction(invoice_update_payment_model, model, payment_id){
 // Automaically Sync Payment with myob payments (same as pressing the button)
// Finally Now make the payment record listing on myob
// console.log('Myob Create Payment: ' + JSON.stringify(model));

// LIVE
model.payment_id = payment_id; // local payment ID
// need to set the model.myob_account_code_id (from 1: to UID.) // run the account functions() so it has an array to filter
this.myobApi_IPTW.getMyobAccountCodes();
/// had to a special is_bulk redirect
this.myobApi_IPTW.setMyobPaymentModelStep1(model);
// this.myobApi_IPTW.getPayment(model.payment_id);

};


createMyobPaymentLocalFunctionW(invoice_update_payment_model, model, payment_id){
  // Automaically Sync Payment with myob payments (same as pressing the button)
 // Finally Now make the payment record listing on myob
 // console.log('Myob Create Payment: ' + JSON.stringify(model));
 
 // LIVE
 model.payment_id = payment_id; // local payment ID
 // need to set the model.myob_account_code_id (from 1: to UID.) // run the account functions() so it has an array to filter
 this.myobApi_IPTW.getMyobAccountCodes();
 /// had to a special is_bulk redirect
 this.myobApi_IPTW.setMyobPaymentModelStep1W(model);
 // this.myobApi_IPTW.getPayment(model.payment_id);
 
 };

updateInvoiceAfterPaymentFigures(invoice_update_payment_model, model, payment_id){
 this._demoService.updateInvoiceAfterPaymentFigures(invoice_update_payment_model).subscribe(
   (data) => {
    // this.new_payment_id = data;
    let res = data[0];
this.toastr.success('Payment + Invoice Record(s) Applied');
// :: TOD refresh the invoice modal below.

// // May need these but was causing a very slow system.
// this.closeParentModel3.emit();
// this.closeParentModel2.emit();

// this.closeParentModel.emit();
// this.refreshInvoiceItemsBelow.emit();
// this.refreshSujectInvoicePage.emit(this.subject_id);
// this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}

// Dont Redirect the pate just yet....
// refreshSujectInvoicePageLocal(subject_id){
//  this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
//                this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));
// }



// ::
// ::
 // NEW


//  Model to insert a payment record per invoice payment. (This way we can delete them and keep all current systems in place)
createPaymentRepeater(model,invoicePaymentItemsList){

// do a repeat through InvoicePaymentItemsList

      // :: Loop a first. Objects
           // tslint:disable-next-line:max-line-length (these are Invoices)
           let newArr = Object(invoicePaymentItemsList).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
           let  count_of_items = Object.keys(newArr).length;
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
           console.log('Invoice Item Update: ' + i);


           this.invoicePaymentModelList.push({
             // // JSON.stringify(invoice_model)
          ...invoicePaymentItemsList[i], // this little bit of code maps t
             // invoice_remaining_total: 0, // paid
             // // payment_amount: invoicePaymentItemsList.invoice_total,
             // invoice_payment_status_id: 2, // paid (there is a part paid but not implimented)
             // invoice_status_id: 5, // closed
             // // required for Insert Invoice Payment Items
               invoice_id: invoicePaymentItemsList[i].invoice_id,
               payment_id :   this.returned_payment_id,
               payment_amount: invoicePaymentItemsList[i].invoice_total,
               payment_date: model.payment_date,
               myob_account_code_id: invoicePaymentItemsList[i].myob_account_code_id,
              //  payment_total: invoicePaymentItemsList[i].invoice_total,
               remaining_total: 0,
               invoice_total: res.invoice_total, // paid
               created_by: model.created_by,
               updated_by: model.updated_by,
               to_brand_id: model.to_brand_id,
               is_bulk: 1, // set so that repeater bulk invoice function works.
               // invoice_id: model.invoice_id,
               // payment_id :   this.returned_payment_id,
               // payment_amount: model.invoice_total,
               // payment_date: model.payment_date,
               // myob_account_code_id: model.myob_account_code_id,
               // payment_total: model.invoice_total,
               // remaining_total: 0,
               // invoice_total: model.invoice_total, // paid
               // created_by: model.created_by,
                 // updated_by: model.updated_by,
                ...model,
                payment_total: invoicePaymentItemsList[i].invoice_total,
               });

              //  console.log('InvoiceID: ' + invoicePaymentItemsList[i].invoice_id);
              //  console.log('InvoiceNUmber: ' + invoicePaymentItemsList[i].invoice_number );
              //  console.log('New invoicePaymentModelList: ' + JSON.stringify(this.invoicePaymentModelList[i]));

           // craete the model here and then push.

          this.createSubjectInvoicePaymentBulk(model, this.returned_payment_id, this.invoicePaymentModelList[0]);
          // this.createSubjectPayment(model);
       setTimeout(() => {
            //  this.createSubjectPayment(this.invoicePaymentModelList[i]); // loop entire process.
            this.createSubjectPayment(this.invoicePaymentModelList[0]); // loop entire process.
          // console.log('Waiting 10 seconds!');
         }, 0);
          // console.log('... off again');

          } // end loop of invoicePaymentItemsList
};



// :: These two functions create the invoice payment + invoice payment Items;
createSubjectPayment(model){
  // :: do the magic here from the form.input model
  this._demoService.createPayment(model).subscribe(
   (data) => {
     this.new_payment_id = data;
     //  let res = data[0];
   this.returned_payment_id = this.new_payment_id.last_insert_id;
   console.log('payment id: ' + this.returned_payment_id);
     // now insert the invoice payment record.
     this.createSubjectInvoicePayment(model, this.returned_payment_id);
   },
   (err) => console.error(err),
  // () => console.log('Brand Loaded.')
 );
 // try here as payment id as not inserting in the subscription

}


createSubjectInvoicePayment(model,  payment_id) {
  // :: do the magic here from the form.input model
  let sent_model = model;
  this._demoService.createSubjectInvoicePayment(model, payment_id).subscribe(
   (data) => {
   //  this.new_payment_id = data;
     //  let res = data[0];
// we now need to update the invoice record with
let payment_status = 2;
let invoice_status = 5;
// partially paid - not allowed yet
if (sent_model.remaining_total > 0) {
payment_status = 3; // partially paid
invoice_status = 4; // approved PDF
}
// if fully paid or more.
if (sent_model.remaining_total < 0){
  payment_status = 2; // fully paid
  invoice_status = 5; // closed
  }


this.invoice_update_payment_model = {
  invoice_id: model.invoice_id,
  invoice_payment_total: model.invoice_total,
  invoice_remaining_total: model.remaining_total,
  invoice_status_id: invoice_status, // closed
  invoice_payment_status_id: payment_status, // fully paid
  updated_by: this.sessionUserId,
};

// Update/Insert Payment Myob Function MYOB BULK WORKS.

  this.createMyobPaymentLocalFunction(this.invoice_update_payment_model, model, payment_id);


console.log('...running next loop');
// Update local values

// this.updateInvoiceAfterPaymentFigures(this.invoice_update_payment_model, model, payment_id);
// setTimeout(() => { console.log('Waiting Again 3.5seconds!'); }, 3000);

},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}

getInvoiceStatusAll(){
  this._demoService.getInvoiceStatusAll().subscribe(
    (data) => {
      this.invoice_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}

getInvoicePaymentStatusAll(){
  this._demoService.getInvoicePaymentStatusAll().subscribe(
    (data) => {
      this.invoice_payment_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getInvoiceCommunicationStatusAll(){
  this._demoService.getInvoiceCommunicationStatusAll().subscribe(
    (data) => {
      this.invoice_communication_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}



}


// Use this file to include as a bulk payment widget for any client , with any outstanding invoices.